<template>
  <v-app
    id="registro"
    
  >

    <v-content style="backgroundImage: url('https://s3.amazonaws.com/descargas.econnectpro.mx/registro.gif'); background-repeat: no-repeat; background-attachment: fixed; background-size:cover; background-position: center center; height:100%" >
      <div style="padding-top:20px; padding-left:20px;" >
        <img
          src="/static/logo_negro.png"
          alt="proControl"
          style="height:62px"
        />
      </div>
      <v-container fluid fill-height style="margin-top:-100px; " >
        <v-layout align-leftjustify-left style="margin-top:100px; margin-left:30px;" >
          <v-flex xs12 sm8 md7 lg7>
            <v-card
              class="elevation-5 black"
              style=" top:30px; left:20px; width: 200px; 
                                transform-origin: left top; padding-left:30px; padding-right:30px;"
            >
              <v-icon small class="white--text" >library_books</v-icon>&nbsp;
              <span class="font-weight-bold white--text caption"
                >Registro ProControl</span
              >
            </v-card>
            <v-card class="elevation-5 pa-3" >
              <v-card-text>
                <v-form ref="form" lazy-validation>
                  <v-container grid-list-md text-xs-center @keyup.enter="registrar()" >
                    <v-layout row wrap>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="person"
                          name="nombre_usuario"
                          label="Nombre(s)"
                          type="text"
                          v-model="model.nombre_usuario"
                          :rules="[model.rules.required]"
                          maxlength="30"
                        ></v-text-field>
                      </v-flex>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="person"
                          name="apellidos"
                          label="Apellido(s)"
                          type="text"
                          v-model="model.apellidos"
                          :rules="[model.rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="contact_mail"
                          @input="model.username = model.username.toLowerCase()"
                          name="username"
                          label="Email"
                          type="text"
                          v-model="model.username"
                          :rules="[model.rules.required, model.rules.email]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="lock"
                          name="password"
                          label="Contraseña"
                          type="password"
                          v-model="model.password"
                          :rules="[model.rules.required]"
                        ></v-text-field>
                      </v-flex>                                      
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="class"
                          @input="model.identificador = model.identificador.toUpperCase()"
                          name="identificador"
                          label="RFC o TAX ID"
                          type="text"
                          v-model="model.identificador"
                          :rules="[model.rules.required, model.rules.rfclen]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex s12 m6 l6>
                        <v-text-field
                          prepend-icon="domain"
                          name="nombre"
                          label="Razón Social"
                          type="text"
                          v-model="model.nombre"
                          :rules="[model.rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex s12 m6 l6>
                          <v-autocomplete :loading="loadingTipos" :items="tipos" v-model="model.tipos_empresa" label="Tipo Industria" item-text="nombre" item-value="id_tipo_empresa" single-line :rules="[model.rules.required]" ></v-autocomplete>
                      </v-flex>
                    </v-layout>                    
                       <v-layout row wrap>
                       <v-flex s21 m12 l12>
                        <v-checkbox
                          v-model="model.aceptaTerminos"
                          @click="verTerminos"
                          :rules="[model.rules.terminos]"
                          readonly
                        >
                          <span slot="label"
                            >He leído y acepto los
                            <span style="text-decoration: underline;"
                              >Términos y Condiciones</span
                            >.</span
                          >
                        </v-checkbox>
                      </v-flex>
                      
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s12 m12 l12>
                        <my-captcha :callSuccess="captchaBtn" color="orange" ></my-captcha>
                      </v-flex>
                      </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn  color="secondary" @click="loginurl" >
                  <v-icon >keyboard_arrow_left</v-icon> Ya tengo cuenta</v-btn
                >
                <v-spacer></v-spacer>
                  
                    <v-btn color="primary" v-bind:disabled="btndis" @click="registrar" :loading="loading"
                      >Registrar <v-icon>keyboard_arrow_right</v-icon></v-btn
                    >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>

        <v-dialog
          v-model="modalterminos"
          max-width="80%"
          persistent
          scrollable
        >
          <v-card>
            <v-card-title>
              <span class="headline" v-text="title" ></span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <div v-html="terminos" ></div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn :loading="loadingPdfTerminos" color="success" @click.native="terminosPDF()" >Descargar PDF</v-btn>
              <v-btn :loading="loadingPdfTerminosEnglish" color="blue" @click.native="terminosPDF('ingles')" >Descargar PDF Inglés</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click.native="
                  modalterminos = false;
                  model.aceptaTerminos = true;
                "
                >Acepto</v-btn
              >
              <v-btn
                color="info"
                @click.native="
                  modalterminos = false;
                  model.aceptaTerminos = false;
                "
                >No Acepto</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import axios from "axios";
import moment from "moment";
import myCaptcha from 'vue-captcha'

export default {
  components: {
    'my-captcha': myCaptcha
  },
  data: () => ({ fab: false,
  tipos:[],
  loadingTipos:true,
    title: "",
     btndis: true,
    modalterminos: false,
    loading: false,
    loadingPdfTerminos:false,
    loadingPdfTerminosEnglish: false,  
    terminos: "",
    toolbar: [[]],
    model: {
      nombre_usuario: "",
      apellidos: "",
      username: "",
      password: "",
      identificador: "",
      nombre: "",
      aceptaTerminos: false,
      rules: {
        required: v => !!v || "Este campo es requerido",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Correo electrónico no valido";
        },
        rfclen: v =>
          (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres",
        terminos: v =>
          v == true || "Debe leer y aceptar los Términos y Condiciones"
      }
    }
  }),

  methods: {
    
    captchaBtn () {
        this.btndis = false
    },
    
    registrar() {
      const axiosConfig = {
        nombre_usuario: this.model.nombre_usuario,
        apellidos: this.model.apellidos,
        username: this.model.username,
        password: this.model.password,
        identificador: this.model.identificador,
        tipos_empresa: this.model.tipos_empresa,
        nombre: this.model.nombre,
        fecha_ingreso: moment(new Date()).format("YYYY-MM-DD"),
        sistema: this.$sistema
      };

      if (!this.$refs.form.validate()) {
        //Alguna operación o alert?
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        axios
          .post(this.$hostname + "clientes/", axiosConfig)          
          .then(res => {
            this.$swal({
              position: "center",
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Se ha enviado un link de confirmación a su correo."
              //showConfirmButton: false,
              //timer: 4500
            });
            this.$router.push("/").catch(()=>{});
          })
          .catch(error => {
            var msg = "";
            if (error.response != null) {
              if (error.response.data.mensaje) {
                msg = error.response.data.mensaje;
              } else {
                if (error.response.data.username)
                  msg += "El email ya ha sido registrado";
                if (error.response.data.identificador)
                  msg += "El RFC ya ha sido registrado";
              }
            } else {
              msg = error;
            }

            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: msg
              //showConfirmButton: false,
            });
          })
          .then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },

    loginurl() {
      this.$router.push("/").catch(()=>{});
    },

    terminosPDF: function(opcion="espanol") {
      if (opcion == "espanol"){
        this.loadingPdfTerminos = true;                              
        var datos = {id:'Terminos.pdf', bucket:'descargas.econnectpro.mx'}
      } else {
        this.loadingPdfTerminosEnglish = true;                              
        var datos = {id:'Terminos_English.pdf', bucket:'descargas.econnectpro.mx'}
      }
      
      axios.post( this.$hostname + 's3/download_url/', datos)          
      .then((res) => {  
        if(typeof res.data !== 'undefined') {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = res.data.mensaje;
          a.target = "_blank";
          //a.download = name[name.length - 1];
          a.click();
          a.parentNode.removeChild(a);                    
        } else {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
            footer: '',
          });   
        }              
      })
      .catch((error) => {
        var mensaje = "Ocurrió un error al descargar el PDF de los términos";
        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
          mensaje = error.response.data.mensaje;
        this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          }); 
        console.log(error);
      }).then(()=>{
        this.loadingPdfTerminos = false;    
        this.loadingPdfTerminosEnglish = false;       
      });
    },
    verTerminos: function(type) {
      this.aceptaTerminos = false;
      axios
        .get(this.$hostname + "terminos/get_ultimo/")
        .then(res => {
          if (res.data[0].contenido) {
            this.terminos = res.data[0].contenido;
            this.title = "Términos y Condiciones";
            this.modalterminos = true;
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se han configurado Términos y Condiciones.",
              footer: ""
            });
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los Términos y Condiciones.",
            footer: ""
          });
          console.log(err);
        });
    }, 
    getTipos: function () {
          axios.get(this.$hostname + "catalogos/tipos_empresas/get_tipos/")
          .then(response => {
              this.tipos = response.data;                    
          })
          .catch(error => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al obtener los tipos.",
                  footer: ""
              });                    
          }).then(()=>{
            this.loadingTipos = false;
          });
    },
  },
  
  created: function() {
    this.getTipos();
    this.$root.$dialogLoader.hide();
    //console.log(this.$router.currentRoute);
  }
};
</script>
<style scoped lang="css" >
#registro {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
<style scope>
  .form {
    margin: 10px;
  }
  .row {
    margin: 10px;
  }
  .button {
    margin-top: 5px;
    background-color: #1D9D74;
    border: 1px solid transparent;
    border-radius: 3px;
    border-color: #dbdbdb;
    text-align: center;
    font-size: 1em;
    height: 2.25em;
    line-height: 1.5;
    color: white;
    cursor: pointer;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
  }
  .button[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }  
</style> 